module.exports = __webpack_public_path__ + "static/media/cover_photo_4.82b197ca.png";